<script>
  import {derived} from "svelte/store";
  import {useParams} from "svelte-navigator"
  import PageBase from "../../PageBase.svelte"
  import {useMe} from "../../../../hooks/useMe.js";
  import {useMyProjectPermission} from "../../../../hooks/useMyProjectPermission.js";
  import { useGlobalProjectDataQuery } from "../../../../hooks/project/views/useGlobalProjectDataQuery.js";
  import { activeDateFormat, mapBackendValueToFormatType } from "../../../../stores/globalProjectStore.js"
  import Loading from "../../Loading.svelte";

  export let parentView = null

  const params = useParams();
  const projectId = $params.project
  const code = derived(params, params => params.code)

  const me = useMe()
  const {permission} = useMyProjectPermission(projectId)

  let backTo
  if (parentView) {
    backTo = `/projects/${projectId}/${parentView}`
  } else {
    backTo = `/projects/${projectId}`
  }

  const handleFetchError = (error) => {
    console.error("Failed to fetch project data:", error);
  };

  const queryResult = useGlobalProjectDataQuery(projectId, handleFetchError);

  $: if ($queryResult.isSuccess && $queryResult.data) {
    const localeDateFormatValue = $queryResult.data.Workspace_LocaleDateFormat;
    if (localeDateFormatValue !== undefined && localeDateFormatValue !== null) {
      const formatType = mapBackendValueToFormatType(localeDateFormatValue);
      console.log(`Workspace localeDateFormat: ${localeDateFormatValue}, setting format to: ${formatType}`);
      activeDateFormat.set(formatType); 
    } else {
       console.warn("Workspace_LocaleDateFormat not found in fetched data. Using default format YMD.");
    }
  }
</script>

<PageBase backTo={backTo}>
  <!-- We need to discern undefined (loading) from null (no permission). -->
  {#if $me && $permission !== undefined}
    <slot code={$code} projectId={projectId} user={$me} permission={$permission} />
  {:else}
    <Loading/>
  {/if}
</PageBase>